export default __webpack_public_path__ + "static/media/warning_alerts.de862723.svg";